export const DATA_HOOK = {
  menuArrow: 'inputShell-menuArrow',
  placeholder: 'inputShell-placeholder',
} as const;

export const SIZE = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;
